import { Grid, IconButton, Typography } from '@material-ui/core/';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ChowbusDialog from '~/components/ui-kit/ChowbusDialog/ChowbusDialog';
import { toPrice } from '~/utils/format';
import { grey } from '@material-ui/core/colors';
import { mixpanel } from '~/third_party/Mixpanel';

export default PriceLine;

function PriceLine(props) {
  const { amount } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!amount) {
    return null;
  }

  function openDialog() {
    setIsDialogOpen(true);
    mixpanel.track({
      name: `User clicks on ${amount.customerDisplayName} fee description`,
    });
  }
  function closeDialog() {
    setIsDialogOpen(false);
  }

  return (
    <Grid container alignItems='center' justify='space-between'>
      <Grid item>
        <Typography component='span'>{amount.customerDisplayName}</Typography>
        {amount.customerDescription && (
          <>
            <IconButton onClick={openDialog} size='small'>
              <InfoOutlinedIcon
                style={{
                  width: 15,
                  height: '100%',
                  color: grey[400],
                }}
              />
            </IconButton>
            <ChowbusDialog
              title={amount.customerDisplayName}
              isDialogOpen={isDialogOpen}
              onCloseDialog={closeDialog}>
              {amount.customerDescription}
            </ChowbusDialog>
          </>
        )}
      </Grid>
      <Grid item>
        <Typography>{toPrice(amount.amount)}</Typography>
      </Grid>
    </Grid>
  );
}

PriceLine.propTypes = {
  amount: PropTypes.shape({
    amount: PropTypes.string.isRequired,
    customerDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    customerDisplayName: PropTypes.string.isRequired,
    customerDisplayGroup: PropTypes.string,
    name: PropTypes.string.isRequired,
  }),
};
